<template>
  <rental-worksite type-vue="update" type-mission="reservation" />
</template>

<script>
import RentalWorksite from '@/components/driver/rentalCoupon/RentalWorksite';
export default {
  name: 'RentalWorksiteUpdate',
  components: { RentalWorksite },
};
</script>
